module.exports = __webpack_public_path__ + "static/media/YM01_8.d02d7739.jpg";